var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 187.16,
    height: 215.231,
    viewBox: "0 0 187.16 215.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration",
    transform: "translate(-236.385 -180.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11719",
    "data-name": "Trac\\xE9 11719",
    d: "M423.545,261.786l-46.79-40.663-46.79-40.662-46.79,40.662-46.79,40.663V395.692h187.16Z",
    transform: "translate(0)",
    fill: "#908ec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11720",
    "data-name": "Trac\\xE9 11720",
    d: "M464.249,313.9l.531-.712-43.005-37.58-43.536-38.044L334.7,275.609l-43.32,37.855V438.571H465.094V313.463l-.314-.275-.531.712H463.4V436.741H293.073v-122.4l42.691-37.306,42.475-37.117,42.475,37.117,43.005,37.58.531-.712h0Z",
    transform: "translate(-48.274 -50.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11721",
    "data-name": "Trac\\xE9 11721",
    d: "M595.145,1599.611H464.43l17-20.4h94.321Z",
    transform: "translate(-200.163 -1227.739)",
    fill: "#7274b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11722",
    "data-name": "Trac\\xE9 11722",
    d: "M858.6,592.221a18.272,18.272,0,0,0-3.234,10.61c.174,3.713,2.1,7.036,2.836,10.627.893,4.344-.591,7.11-3.554,10.157-2.187,2.247-4.061,6.355-3.578,9.539.463,3.056,3.974,4.253,4.26,7.163.267,2.716-2.467,5.18-.3,7.627,2.143,2.418,5.735,2.12,8.611,1.913a92.141,92.141,0,0,1,14.392,0c3.561.3,6.7-.294,9.156-3.065a7.987,7.987,0,0,0,1.164-8.994c-1.374-3.054-4.893-7.02-3.2-10.613,1.486-3.157,4.379-3.486,4.43-7.49.059-4.481-3.094-6.973-5.585-10.23-3.511-4.59,1.646-6.378,1.84-10.562.141-3.038-2.386-8.6-4.458-10.567-3.036-2.879-10.121-3.552-13.71-2.281C863.866,587.4,860.684,589,858.6,592.221Z",
    transform: "translate(-546.102 -355.466)",
    fill: "#00345f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11723",
    "data-name": "Trac\\xE9 11723",
    d: "M922.882,613.936a10.436,10.436,0,0,0,10.06-.565,17.586,17.586,0,0,0,4.128-3.718c5.463-7.06,5.061-17.917.33-24.46-4.27-5.905-13.387-5.555-18.672-1.136a16.361,16.361,0,0,0-4.354,5.937c-2.263,5.5-1.2,14.111,2.892,19.513A14.312,14.312,0,0,0,922.882,613.936Z",
    transform: "translate(-600.93 -351.347)",
    fill: "#00345f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11724",
    "data-name": "Trac\\xE9 11724",
    d: "M987.38,854.194h10.593c-2.435-3.945-.524-9.272-.244-10h-10.1C987.9,844.922,989.814,850.248,987.38,854.194Z",
    transform: "translate(-666.099 -582.584)",
    fill: "#f5a58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11725",
    "data-name": "Trac\\xE9 11725",
    d: "M998.507,849.316a15.8,15.8,0,0,1,.972-5.121h-10.1a15.8,15.8,0,0,1,.972,5.121S994.219,853.623,998.507,849.316Z",
    transform: "translate(-667.85 -582.584)",
    fill: "#f0856d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11726",
    "data-name": "Trac\\xE9 11726",
    d: "M960.827,649.754a5.861,5.861,0,0,0,2.238-3.893c.344-3.68.509-4.9.783-6.774,1.178-8.061-4.627-14.757-10.391-14.843-5.764.086-11.569,6.782-10.391,14.843.275,1.879.439,3.094.784,6.774a7.039,7.039,0,0,0,2.238,3.893,20.507,20.507,0,0,0,6.1,4.108,4.3,4.3,0,0,0,2.548,0S959.232,651.5,960.827,649.754Z",
    transform: "translate(-627.037 -389.524)",
    fill: "#f5a58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11727",
    "data-name": "Trac\\xE9 11727",
    d: "M1060.728,704.579a.441.441,0,0,1-.335-.154,1.794,1.794,0,0,0-2.412-.184.443.443,0,0,1-.5-.732,2.7,2.7,0,0,1,3.584.337.443.443,0,0,1-.336.733Z",
    transform: "translate(-727.846 -458.639)",
    fill: "#0c1f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11728",
    "data-name": "Trac\\xE9 11728",
    d: "M973.537,704.579a.443.443,0,0,1-.335-.733,2.7,2.7,0,0,1,3.585-.337.443.443,0,0,1-.5.732,1.794,1.794,0,0,0-2.413.184A.44.44,0,0,1,973.537,704.579Z",
    transform: "translate(-653.197 -458.639)",
    fill: "#0c1f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11729",
    "data-name": "Trac\\xE9 11729",
    d: "M1016.192,748.377a.341.341,0,0,1-.341-.342c0-.731-.494-1.045-1.139-1.378-.368-.192-.718-.372-.737-.739-.02-.351.3-.611.61-.818l.112-.075c.729-.481.729-.481.729-1.832a.341.341,0,1,1,.683,0c0,1.6-.024,1.734-1.034,2.4l-.111.074a1.8,1.8,0,0,0-.26.2c.082.055.217.125.324.18a2.233,2.233,0,0,1,1.506,1.985A.341.341,0,0,1,1016.192,748.377Z",
    transform: "translate(-689.397 -493.63)",
    fill: "#ee7d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11730",
    "data-name": "Trac\\xE9 11730",
    d: "M1014.094,792.264a2.6,2.6,0,0,1-2.556-1.471.342.342,0,0,1,.646-.226,2.042,2.042,0,0,0,2.1,1.007c.678-.045,1.454-.346,1.6-1.052a.342.342,0,0,1,.67.138,2.215,2.215,0,0,1-2.224,1.6C1014.25,792.262,1014.172,792.264,1014.094,792.264Z",
    transform: "translate(-687.307 -535.233)",
    fill: "#ee7d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11731",
    "data-name": "Trac\\xE9 11731",
    d: "M1055.96,729.621a1.668,1.668,0,0,1-1.667-1.667.341.341,0,1,1,.681,0,.985.985,0,1,0,1.971,0,.341.341,0,1,1,.681,0A1.669,1.669,0,0,1,1055.96,729.621Z",
    transform: "translate(-725.171 -480.255)",
    fill: "#0c1f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11732",
    "data-name": "Trac\\xE9 11732",
    d: "M978.419,729.621a1.669,1.669,0,0,1-1.668-1.667.341.341,0,1,1,.681,0,.986.986,0,0,0,1.973,0,.341.341,0,1,1,.681,0A1.669,1.669,0,0,1,978.419,729.621Z",
    transform: "translate(-656.421 -480.255)",
    fill: "#0c1f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11733",
    "data-name": "Trac\\xE9 11733",
    d: "M1059.888,752.454c0,.659-1.056,1.193-2.359,1.193s-2.357-.534-2.357-1.193,1.055-1.193,2.357-1.193S1059.888,751.8,1059.888,752.454Z",
    transform: "translate(-726.002 -501.012)",
    fill: "#ec7c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11734",
    "data-name": "Trac\\xE9 11734",
    d: "M971.14,752.454c0,.659-1.055,1.193-2.358,1.193s-2.358-.534-2.358-1.193,1.056-1.193,2.358-1.193S971.14,751.8,971.14,752.454Z",
    transform: "translate(-647.311 -501.012)",
    fill: "#ec7c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11735",
    "data-name": "Trac\\xE9 11735",
    d: "M891.471,935.395c2.432-5.434,1.857-9.1,1.857-9.1-1.25-5.164-9.085-6.954-9.085-6.954-7.823-2.386-8.677-4.743-8.677-4.743h-8.8s-.855,2.357-8.678,4.743c0,0-7.835,1.79-9.085,6.954,0,0-.576,3.67,1.857,9.1,0,0,5.7,14.563,8.142,21.38,0,0,1.889,4.318-.914,11.135l-3.926,9.317h34.006l-3.924-9.317c-2.8-6.817-.914-11.135-.914-11.135C885.768,949.958,891.471,935.395,891.471,935.395Z",
    transform: "translate(-544.528 -644.376)",
    fill: "#f5a58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11736",
    "data-name": "Trac\\xE9 11736",
    d: "M905.584,1395.852c-2.047-3.81-4.784-9.309-4.784-9.309-.326,3.1-13.517,3.268-15.377,3.285-1.771-.017-13.292-.215-14.528-3.162,0,0-3.034,5.4-4.962,9.186,0,0-3.789,9.005,19.246,10.5v.031l.239-.015.237.015v-.031C908.7,1404.858,905.584,1395.852,905.584,1395.852Z",
    transform: "translate(-559.232 -1058.623)",
    fill: "#415980"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11737",
    "data-name": "Trac\\xE9 11737",
    d: "M1103.808,752.652c-.17,1.553-1.258,2.708-2.432,2.579s-1.985-1.492-1.815-3.045,1.26-2.707,2.432-2.579S1103.979,751.1,1103.808,752.652Z",
    transform: "translate(-765.325 -499.552)",
    fill: "#f5a58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11738",
    "data-name": "Trac\\xE9 11738",
    d: "M1115.993,761.2a.342.342,0,0,1-.212-.611,1.95,1.95,0,0,0,.482-1.585.838.838,0,0,0-.361-.694.342.342,0,1,1,.292-.618,1.46,1.46,0,0,1,.748,1.235,2.636,2.636,0,0,1-.738,2.2A.337.337,0,0,1,1115.993,761.2Z",
    transform: "translate(-779.493 -506.63)",
    fill: "#ee7d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11739",
    "data-name": "Trac\\xE9 11739",
    d: "M1112.445,767.8a.34.34,0,0,1-.24-.1,1.107,1.107,0,0,0-.848-.105.342.342,0,0,1-.121-.673,1.757,1.757,0,0,1,1.451.294.342.342,0,0,1-.241.584Z",
    transform: "translate(-775.349 -514.722)",
    fill: "#ee7d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11740",
    "data-name": "Trac\\xE9 11740",
    d: "M925.54,752.652c.17,1.553,1.26,2.708,2.432,2.579s1.987-1.492,1.816-3.045-1.26-2.707-2.432-2.579S925.369,751.1,925.54,752.652Z",
    transform: "translate(-611.026 -499.552)",
    fill: "#f5a58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11741",
    "data-name": "Trac\\xE9 11741",
    d: "M934.783,761.2a.34.34,0,0,1-.212-.074,2.638,2.638,0,0,1-.738-2.2,1.463,1.463,0,0,1,.748-1.236.342.342,0,0,1,.293.618.834.834,0,0,0-.361.695,1.954,1.954,0,0,0,.482,1.585.342.342,0,0,1-.212.611Z",
    transform: "translate(-618.292 -506.63)",
    fill: "#ee7d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11742",
    "data-name": "Trac\\xE9 11742",
    d: "M934.567,767.8a.342.342,0,0,1-.242-.584,1.752,1.752,0,0,1,1.451-.294.342.342,0,0,1,.276.4.345.345,0,0,1-.4.276,1.1,1.1,0,0,0-.846.1A.339.339,0,0,1,934.567,767.8Z",
    transform: "translate(-618.67 -514.721)",
    fill: "#ee7d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11743",
    "data-name": "Trac\\xE9 11743",
    d: "M770.247,970.988c-2.6,8.29-7.125,21.318-9.531,29.306,0,0,4.816,9.185,6.808,5.909,5.233-8.606,5.454-9.96,13.416-29.558,0,0,3.174-9.176-3.123-14.271C777.817,962.373,772.751,963.18,770.247,970.988Z",
    transform: "translate(-465.337 -686.313)",
    fill: "#f5a58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11744",
    "data-name": "Trac\\xE9 11744",
    d: "M1143.271,970.988c2.6,8.29,7.126,21.318,9.532,29.306,0,0-4.818,9.185-6.809,5.909-5.233-8.606-5.454-9.96-13.415-29.558,0,0-3.175-9.176,3.122-14.271C1135.7,962.373,1140.768,963.18,1143.271,970.988Z",
    transform: "translate(-794.65 -686.313)",
    fill: "#f5a58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11745",
    "data-name": "Trac\\xE9 11745",
    d: "M1240.944,1249.487s-22.161-1.434-32.628-3.524a53.129,53.129,0,0,1-6.3-11.237s4.764.5,11.337,1.836c0,0,22.588,7.907,28.8,9.664Z",
    transform: "translate(-858.101 -925.367)",
    fill: "#f5a58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11746",
    "data-name": "Trac\\xE9 11746",
    d: "M1520.225,1308.968c-.031-1.79-2.543-1.8-3.529-2.082,0,0-.527,1,1.3,1.605l-.928.792-4.12-.132a5.834,5.834,0,0,1,1.033-.991c-.354-.061,2.266.313,2.716-1.274a9.574,9.574,0,0,0-3.917-.177c-1.13.112-3.453,2.594-3.453,2.594l-2.347.119-.571,2.908,1.906.828c1.825,1.912,6.391,2.653,6.391,2.653,1,.383,4.582.712,5.43-.061-.192-.776-2.226-1.035-4.61-1.834,2.524.4,6.745,1.524,7.474.385-.271-1.006-5.27-1.29-7.149-1.589,1.175-.1,8.067.952,8.115-.083-.254-1.094-6.214-1.391-6.269-1.386Z",
    transform: "translate(-1129.143 -988.444)",
    fill: "#f5a58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11747",
    "data-name": "Trac\\xE9 11747",
    d: "M535.605,1249.487s22.161-1.434,32.628-3.524c0,0,.6.429,6.3-11.237,0,0-4.764.5-11.337,1.836,0,0-22.589,7.907-28.8,9.664Z",
    transform: "translate(-264.827 -925.367)",
    fill: "#f5a58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11748",
    "data-name": "Trac\\xE9 11748",
    d: "M418.416,1308.968c.031-1.79,2.544-1.8,3.529-2.082,0,0,.527,1-1.3,1.605l.928.792,4.12-.132a5.822,5.822,0,0,0-1.033-.991c.355-.061-2.266.313-2.715-1.274a9.571,9.571,0,0,1,3.916-.177c1.131.112,3.453,2.594,3.453,2.594l2.347.119.572,2.908-1.906.828c-1.825,1.912-6.391,2.653-6.391,2.653-1,.383-4.582.712-5.43-.061.192-.776,2.226-1.035,4.61-1.834-2.524.4-6.746,1.524-7.474.385.272-1.006,5.27-1.29,7.149-1.589-1.174-.1-8.066.952-8.114-.083.254-1.094,6.214-1.391,6.269-1.386Z",
    transform: "translate(-156.494 -988.444)",
    fill: "#f5a58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11749",
    "data-name": "Trac\\xE9 11749",
    d: "M918.528,997.935l2.633,6.186H886.532l1.355-6.083-.487-26.6c6.12-11.27,1.084-24.545,1.084-24.545,1.416-.409,4.31-1.209,5.037-1.48,0,0-.5,7.272,10.886,7.045,0,0,8.814,1.012,9.93-7.22.841.327,4.17,1.32,5.268,1.656,0,0-4.017,13.275,1.5,24.071l-2.572,26.973",
    transform: "translate(-577.514 -671.271)",
    fill: "#385896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11750",
    "data-name": "Trac\\xE9 11750",
    d: "M569.492,1401.88h81.759c10.912,1.275,23.943-13.412,14.255-15.813-19.147-4.745-40.733-3.615-40.733-3.615l-3.35-6.187s-12.927,4.031-30.641.1c-1.1,4.337-1.1,4.337-2.516,7.166,0,0-28.261-3.552-40.223,6.806C548.043,1390.342,552.222,1401.88,569.492,1401.88Z",
    transform: "translate(-280.352 -1049.603)",
    fill: "#012b42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11751",
    "data-name": "Trac\\xE9 11751",
    d: "M611.63,1484.723s-.2,3.456-1.363,4.2c0,0-7.726,1.534-21.928-.341-1.875-.091-18.8,1.891-19.2,1.875-11.774-.451-16.4.948-27.256-3.8-4.033-1.763-12.03-13.373-3.668-17.514,9.667-5.78,31.94,7.361,31.948,7.366,6.09,3.594,13.411,4.982,20.4,4.807C594.5,1481.223,611.43,1477.411,611.63,1484.723Z",
    transform: "translate(-265.921 -1129.839)",
    fill: "#012b42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11752",
    "data-name": "Trac\\xE9 11752",
    d: "M973.49,1554.626a28.023,28.023,0,0,1-13.61-.562,6.017,6.017,0,0,0-6.69.747s-1.971,3.982-9.584,1.71c0,0-1.738.466-2.03,1.932,0,0-1.59,3.067,1.364,4.2,0,0,7.727,1.534,21.929-.341.831-.04,4.624.327,8.621.747Z",
    transform: "translate(-625.929 -1205.038)",
    fill: "#f5a58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11753",
    "data-name": "Trac\\xE9 11753",
    d: "M1225.564,1457.131c-9.669-5.781-31.948,7.366-31.948,7.366a23.5,23.5,0,0,1-12.568,4.844v7.664c5.611.558,13.322,1.447,13.591,1.437,11.774-.45,16.4.948,27.256-3.8C1225.93,1472.883,1233.926,1461.272,1225.564,1457.131Z",
    transform: "translate(-840.008 -1119.291)",
    fill: "#012b42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11754",
    "data-name": "Trac\\xE9 11754",
    d: "M1028.256,1475.165a.341.341,0,0,1-.271-.547c2.5-3.305,5.2-2.753,7.577-2.267.519.106,1.009.206,1.485.264.908.111,1.805.244,2.7.377a37.022,37.022,0,0,0,6.621.588c5.522-.179,9.88-2.838,14.493-5.653a65.65,65.65,0,0,1,6.683-3.728l.736-.341a29.043,29.043,0,0,1,9.572-3,.341.341,0,0,1,.078.677,28.448,28.448,0,0,0-9.362,2.944l-.739.342a65.205,65.205,0,0,0-6.614,3.69c-4.485,2.737-9.124,5.568-14.825,5.752a36.753,36.753,0,0,1-6.744-.594c-.884-.132-1.775-.264-2.677-.374-.5-.061-1.006-.164-1.538-.273-2.29-.468-4.656-.952-6.9,2.011A.339.339,0,0,1,1028.256,1475.165Z",
    transform: "translate(-703.968 -1123.846)",
    fill: "#0c1f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11755",
    "data-name": "Trac\\xE9 11755",
    d: "M950.611,951.444a25.29,25.29,0,0,1-6.8-.8c-2.661-.822-5.282-3.431-4.9-6.647a.344.344,0,0,1,.379-.3.34.34,0,0,1,.3.379c-.329,2.745,1.99,5.163,4.421,5.915a27.707,27.707,0,0,0,9.056.674.341.341,0,0,1,.055.68C952.31,951.412,951.461,951.444,950.611,951.444Z",
    transform: "translate(-623.22 -669.921)",
    fill: "#0c1f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11756",
    "data-name": "Trac\\xE9 11756",
    d: "M936.343,1379.971a63.3,63.3,0,0,1-13.646-1.453.341.341,0,1,1,.146-.666,63.159,63.159,0,0,0,14.717,1.426,50.539,50.539,0,0,0,7.118-.559,18.056,18.056,0,0,0,3.443-.854.341.341,0,0,1,.237.639,18.681,18.681,0,0,1-3.572.888,51.23,51.23,0,0,1-7.213.567Q936.956,1379.971,936.343,1379.971Z",
    transform: "translate(-609.051 -1050.988)",
    fill: "#0c1f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11757",
    "data-name": "Trac\\xE9 11757",
    d: "M795.89,958.777s-6.647.71-10.482,11.276l-4.367,12.519s5.39,6.286,13.8,6.853l6.334-17.071S804.241,963.35,795.89,958.777Z",
    transform: "translate(-483.365 -683.157)",
    fill: "#385896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11758",
    "data-name": "Trac\\xE9 11758",
    d: "M1115.152,958.777s6.647.71,10.482,11.276L1130,982.572s-5.389,6.286-13.8,6.853l-6.335-17.071S1106.8,963.35,1115.152,958.777Z",
    transform: "translate(-774.701 -683.157)",
    fill: "#385896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11759",
    "data-name": "Trac\\xE9 11759",
    d: "M934.253,1571.854a44.426,44.426,0,0,1-8.093-.611l-.084,8.256c2.875-.258,5.25-.443,5.887-.405,14.183,2.02,21.924.565,21.924.565,1.172-.736,1.406-4.189,1.406-4.189C955.169,1568.156,938.2,1571.8,934.253,1571.854Z",
    transform: "translate(-612.413 -1220.438)",
    fill: "#f5a58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11760",
    "data-name": "Trac\\xE9 11760",
    d: "M586.091,1481.212a36.621,36.621,0,0,1-15.932-4.7c-.008,0-22.281-13.146-31.948-7.366-8.362,4.141-.365,15.751,3.668,17.514,10.858,4.746,15.482,3.347,27.256,3.8.329.013,11.838-1.325,16.955-1.75Z",
    transform: "translate(-265.204 -1129.839)",
    fill: "#012b42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11761",
    "data-name": "Trac\\xE9 11761",
    d: "M712.144,1491.848a.341.341,0,0,1-.142-.651,2.688,2.688,0,0,0,1.4-2.281,5.711,5.711,0,0,0-1.585-4.641c-1.711-1.3-3.848-1.161-5.915-1.024-.416.028-.831.055-1.24.071-1.349.054-2.65.191-4.026.337-1.342.142-2.729.289-4.153.348-5.435.228-10.747.337-15.976-.822-3.776-.837-7.12-2.752-10.355-4.6-1.466-.839-2.983-1.707-4.506-2.453l-1.112-.549c-4.067-2.013-9.136-4.521-13.557-4.355a.317.317,0,0,1-.353-.328.341.341,0,0,1,.328-.353c4.587-.186,9.749,2.378,13.885,4.426l1.109.547c1.544.756,3.069,1.63,4.544,2.474,3.191,1.826,6.49,3.714,10.165,4.529,5.149,1.141,10.41,1.032,15.8.807,1.4-.059,2.779-.2,4.11-.346s2.7-.286,4.071-.341c.4-.016.811-.043,1.222-.07,2.195-.145,4.459-.294,6.373,1.162a6.365,6.365,0,0,1,1.849,5.258,3.314,3.314,0,0,1-1.789,2.826Z",
    transform: "translate(-368.87 -1132.346)",
    fill: "#0c1f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11762",
    "data-name": "Trac\\xE9 11762",
    d: "M1132.514,1590.6a6.6,6.6,0,0,1-1.5-.157.341.341,0,1,1,.157-.663,8.449,8.449,0,0,0,3.127-.036.341.341,0,1,1,.142.666A10.065,10.065,0,0,1,1132.514,1590.6Z",
    transform: "translate(-792.984 -1236.976)",
    fill: "#0c1f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11763",
    "data-name": "Trac\\xE9 11763",
    d: "M1139.247,1604.9c-.34,0-.718-.013-1.125-.049a.341.341,0,1,1,.059-.679,10.462,10.462,0,0,0,2.787-.095.341.341,0,0,1,.142.667A9.693,9.693,0,0,1,1139.247,1604.9Z",
    transform: "translate(-799.229 -1249.553)",
    fill: "#0c1f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11764",
    "data-name": "Trac\\xE9 11764",
    d: "M1141.176,1620.163c-.208,0-.413-.008-.6-.027a.341.341,0,0,1-.307-.372.345.345,0,0,1,.373-.306,13.147,13.147,0,0,0,2.8-.195.344.344,0,0,1,.4.275.341.341,0,0,1-.276.4A15.626,15.626,0,0,1,1141.176,1620.163Z",
    transform: "translate(-801.405 -1262.885)",
    fill: "#0c1f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11765",
    "data-name": "Trac\\xE9 11765",
    d: "M1006.108,588.724c2.109,1.8,3.5,7.17,2.854,9.779-.51,2.071-1.959,3.823-2.165,5.978-.339,3.555,3.322,5.787,3.43,9.263.122,3.931-2.7,6.971-4.184,10.379-1.63,3.73-.043,7.552.733,11.27.609,2.915-.931,8.284,1.56,10.381a6.832,6.832,0,0,0,6.062.882c3.136-1.233,2.64-5.106,4.585-7.295,1.9-2.134,7.159-.6,7.845-3.928.5-2.419-2.23-4.9-3.146-6.977-2.136-4.852,1.955-9.945-.441-14.414-1.23-2.292-2.974-3.9-3.191-6.689-.2-2.563,1.654-4.909-.047-7.286-1.834-2.564-3.093-3.764-2.855-7.03.55-7.564-3.756-10.463-6.238-11.545-12.9-5.622-12.5,7.261-12.5,7.261A9.8,9.8,0,0,1,1006.108,588.724Z",
    transform: "translate(-676.606 -350.752)",
    fill: "#00345f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11766",
    "data-name": "Trac\\xE9 11766",
    d: "M935.833,611.464a7.786,7.786,0,0,1,3.984-3.176c3.215-1.031,7.464-.5,9.8,2.239a12.11,12.11,0,0,1,2.749,6.562c.073.747.118,4.171,1.642,3.495,1.284-.569,1.119-5.147.947-6.163a15.366,15.366,0,0,0-2.039-5.908,13.226,13.226,0,0,0-10.117-5.883c-4.47-.366-9.063,2.955-10.795,7.022-.516,1.212-2.171,10.564.113,10.932,1.288.208,1.629-3.935,1.8-4.662A13.654,13.654,0,0,1,935.833,611.464Z",
    transform: "translate(-616.524 -370.528)",
    fill: "#00345f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11767",
    "data-name": "Trac\\xE9 11767",
    d: "M1268.742,1249.739a.341.341,0,0,1-.292-.516c.5-.844,2.155-2.362,3.844-2.21a.341.341,0,0,1,.31.37.35.35,0,0,1-.37.31,4.092,4.092,0,0,0-3.2,1.88A.34.34,0,0,1,1268.742,1249.739Z",
    transform: "translate(-915.044 -936.143)",
    fill: "#0c1f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11768",
    "data-name": "Trac\\xE9 11768",
    d: "M764.865,1249.192a.339.339,0,0,1-.259-.12c-.773-.907-2.1-1.633-3.148-1.263a.341.341,0,1,1-.228-.643c1.4-.5,3,.412,3.9,1.464a.341.341,0,0,1-.039.48A.338.338,0,0,1,764.865,1249.192Z",
    transform: "translate(-465.156 -936.165)",
    fill: "#0c1f3f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessee);
export default __webpack_public_path__ + "static/media/lessee.05270a435e71e91ff35b7b0876e5972e.svg";
export { ForwardRef as ReactComponent };